export const state = {
	arr: [],
	openMO: {
		// name: 'asd'
	}
};
